import Webfx from "../../assets/cropped/site_Webfx.webp"
import Aware from "../../assets/cropped/site_Aware.webp"
import Pfitravel from "../../assets/cropped/site_Pfitravel.webp"
import Elementor from '../../assets/elementor-pink.png'
import Beaver from '../../assets/beaver.png'
import Code from '../../assets/code.png'
import Lms_MM from '../../assets/cropped/lms_mm.webp'
import Fortis from '../../assets/cropped/fortis.webp'
import Elites from '../../assets/cropped/elites.webp'



export default [
    {
        title:'LMS Moving Mindsets',
        category:'LMS',
        url:'https://lms.movingmindsets.com.au/',
        image: Lms_MM,
        builder: Elementor,
        build: "Elementor/Custom Code",
    },
    {
        title:'Elites Empire',
        category:'Marketing',
        url:'https://elitesempire.com/',
        image: Elites,
        builder: Elementor,
        build: "Elementor/Custom Code",
    },
    {
        title:'Fortis Construction',
        category:'Marketing, Custom',
        url:'https://fortisconstruction.com/',
        image: Fortis,
        builder: Elementor,
        build: "Elementor/Custom Code",
    },
    {
        title:'Aware Group Online',
        category:'E-commerce, Membership',
        url:'http://awaregroup.online/',
        image: Aware,
        builder: Beaver,
        build: "Beaver Builder",
    },
    {
        title:'Web and Graphics Delonix',
        category:'Marketing, Custom',
        url:'https://webandgraphics.delonix.com.au/',
        image: Webfx,
        builder: Code,
        build: "Custom Code",
    },
    {
        title:'Passion for Italy',
        category:'Marketing, Custom',
        url:'https://pfitravel.com/',
        image: Pfitravel,
        builder: Beaver,
        build: "Beaver Builder",
    },
   
    
  
] 

